export const getClampToMax = (realMaxValue: number, maxValueConst: number): number => {
  return realMaxValue < maxValueConst ? realMaxValue : maxValueConst;
};
